import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("local_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const CATEGORIAS = [
  { key: "BEBES", label: "Bebés", range: "0 - 12 m" },
  { key: "BENJAMINES", label: "Benjamines", range: "1 - 3 años" },
  { key: "INFANTILES", label: "Infantiles", range: "4 - 13 años" },
  { key: "JUVENILES", label: "Juveniles", range: "14 - 17 años" },
  { key: "ADULTOS", label: "Adultos", range: "+18 años" },
];

export const CATEGORIA_STYLES = {
  BEBES: "bg-[#FDE68A] text-[#92400E] ring-1 ring-[#F0C75B]/40",
  BENJAMINES: "bg-[#FFEDD5] text-[#9A3412] ring-1 ring-[#F1B98E]/40",
  INFANTILES: "bg-[#D1FAE5] text-[#065F46] ring-1 ring-[#7DDFB4]/40",
  JUVENILES: "bg-[#E0F2FE] text-[#0369A1] ring-1 ring-[#7CC4F0]/40",
  ADULTOS: "bg-[#FFE4E6] text-[#BE123C] ring-1 ring-[#F1A8B5]/40",
};

export const formatEUR = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
  }).format(Number(n || 0));

export const formatDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return s;
  }
};
